import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagCM(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURdMTKN4XLQB/Yf7XLf7THv/bPAKGZwSObe+LKuFCK1Q0uvwAAAGESURBVDjL7Y+/SwQxEIVnOq9LCkG7Y4vUJ9mApZAUZ3cQrr9Nka1tYnsigqUHCv65vsn+4E48xN63yy7s++abLD3OedBztnM29A/8CSjngX5IKeUIiBGd28Zt3FB57Ie7PzE450A5B0MpMp9L6Y4MbsqKelTl+wpMxwko/ZROobqWnqONY7AiZ0hyLn2nldKXmpm1c1au6OyGct8LAQQG1h8HMVgYah9XgyEL1jEr9fJUDRaIlcAgfkEyVuB4N5oVi74KYMhzOv4MmAnrg7ZzjoGd5md8ck+kfgY6Ulf4dIuTnDEwExR7dRZA8+z9nk9XmJyywSUAU1iHO7zQ+NZ6PGAYCWN2TIvw9n5Pitp2IlaE1tQNaUd8sSd6JazwQISoBpOSkewULYhowQSDxHoPQ+1SSk1aosUB5QE3HC2AO2pSg1uoJUbHhFDbCoi+SZLlUOInyEsffGgBoBVJ05glHRl8lYQWK5rR0FRgWCPj1RAEmHJiGCMG8xMgw16I3wz/wAR8AVlzP262Yua9AAAAAElFTkSuQmCC",
    alt: "CM"
  }, props));
}